import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import "../../../styles/web.css"

const Website = () => {
  const location = useLocation();
  const sectionRefs = useRef({});
  const platformData = {
    title: "Websites",
    description: "Responsive and dynamic web solutions",
    icon: "🌐",
    color: "#10b981",
    sections: [
      {
        id: "readers-menu",
        title: "Readers Menu",
        description: "Content and information portal for diverse topics",
        items: ["Information", "HealthTips", "Education", "TechTips"],
        features: [
          "Content management system",
          "Multi-category organization",
          "User engagement tools",
          "Analytics dashboard"
        ],
        images: [
          "/assets/rmweb/1.png",
          "/assets/rmweb/2.png",
          "/assets/rmweb/3.png",
          "/assets/rmweb/4.png",
        ],
        liveLink: "https://readersmenu.com/",
        demoLink: "https://readersmenu.com/",
        sourceLink: "https://readersmenu.com/"
      },
      {
        id: "today-talks",
        title: "Today Talks",
        description: "Discussion and news platform for current affairs",
        items: ["Sports", "Entertainment", "Education", "AIPrompts"],
        features: [
          "Real-time discussions",
          "News aggregation",
          "Interactive forums",
          "AI-powered insights"
        ],
        images: [
          "/assets/ttweb/1.png",
          "/assets/ttweb/2.png",
          "/assets/ttweb/3.png",
          "/assets/ttweb/4.png",
        ],
        liveLink: "https://todaytalks.in/",
        demoLink: "https://todaytalks.in/",
        sourceLink: "https://todaytalks.in/"
      },
      {
        id: "erode-book-festival",
        title: "Erode Book Festival",
        description: "Literary and cultural event platform",
        items: ["Barathi Vizha", "News", "Meetings", "Publications"],
        features: [
          "Event registration",
          "Author profiles",
          "Book catalog",
          "Schedule management"
        ],
        images: [
          "/assets/ebfweb/1.png",
          "/assets/ebfweb/2.png",
          "/assets/ebfweb/3.png",
          "/assets/ebfweb/4.png"
        ],
        liveLink: "https://www.erodebookfestival.in/",
        demoLink: "https://www.erodebookfestival.in/",
        sourceLink: "https://www.erodebookfestival.in/"
      },
      {
        id: "makkal-sinthani-peravai-web",
        title: "Makkal Sinthani Peravai",
        description: "CMS and content management solutions",
        items: ["WordPress", "Custom CMS", "Headless CMS", "Content Management", "Blog Platforms"],
        features: [
          "Multiple CMS options",
          "Custom development",
          "Headless architecture",
          "Blog management"
        ],
        images: [
          "/assets/mspweb/1.png",
          "/assets/mspweb/2.png",
          "/assets/mspweb/3.png",
          "/assets/mspweb/4.png"
        ],
        liveLink: "https://www.makkalsinthanaiperavai.com/",
        demoLink: "https://www.makkalsinthanaiperavai.com/",
        sourceLink: "https://www.makkalsinthanaiperavai.com/"
      },
      {
        id: "tstalin-gunasekaran",
        title: "TStalin Gunasekaran",
        description: "Personal portfolio and information platform",
        items: ["Personal Information", "Portfolio", "Interviews", "Publications"],
        features: [
          "Portfolio showcase",
          "Media gallery",
          "Interview archives",
          "Publication database"
        ],
        images: [
          "/assets/tsgweb/1.png",
          "/assets/tsgweb/2.png",
          "/assets/tsgweb/3.png",
          "/assets/tsgweb/4.png"
        ],
        liveLink: "https://tstalingunasekaran.in/",
        demoLink: "https://tstalingunasekaran.in/",
        sourceLink: "https://tstalingunasekaran.in/"
      },
      {
        id: "makkal-naatkaati",
        title: "Makkal Naatkaati",
        description: "Calendar and traditional information platform",
        items: ["Calendar", "Rasi", "Panchangam", "Natchathiram"],
        features: [
          "Traditional calendar",
          "Astrological information",
          "Event reminders",
          "Cultural insights"
        ],
        images: [
          "/assets/mnweb/1.png",
          "/assets/mnweb/2.png",
          "/assets/mnweb/3.png",
          "/assets/mnweb/4.png"
        ],
        liveLink: "https://makkalcalendar.mpeoples.in/",
        demoLink: "https://makkalcalendar.mpeoples.in/",
        sourceLink: "https://makkalcalendar.mpeoples.in/"
      }
    ]
  };
  const [activeImageIndex, setActiveImageIndex] = useState(() => {
    const initialIndices = {};
    platformData.sections.forEach(section => {
      initialIndices[section.id] = 0;
    });
    return initialIndices;
  });

  useEffect(() => {
    const hash = location.hash.replace('#', '');
    if (hash && sectionRefs.current[hash]) {
      setTimeout(() => {
        sectionRefs.current[hash].scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }, 100);
    }
  }, [location.hash]);

  const nextImage = (sectionId) => {
    const currentIndex = activeImageIndex[sectionId];
    const totalImages = platformData.sections.find(s => s.id === sectionId).images.length;
    setActiveImageIndex({
      ...activeImageIndex,
      [sectionId]: (currentIndex + 1) % totalImages
    });
  };

  const prevImage = (sectionId) => {
    const currentIndex = activeImageIndex[sectionId];
    const totalImages = platformData.sections.find(s => s.id === sectionId).images.length;
    setActiveImageIndex({
      ...activeImageIndex,
      [sectionId]: (currentIndex - 1 + totalImages) % totalImages
    });
  };

  const goToImage = (sectionId, index) => {
    setActiveImageIndex({
      ...activeImageIndex,
      [sectionId]: index
    });
  };

  return (
    <div className="platform-page3">
      {/* Hero Section */}
      <div
        className="platform-hero3"
        style={{ "--hero-color": platformData.color }}
      >
        <div className="platform-hero-content3">

          <span className="platform-eyebrow3">
            {platformData.category || "Platform Overview"}
          </span>

          <h1>{platformData.title}</h1>

          <p className="platform-description3">
            {platformData.description}
          </p>

          <div className="platform-meta3">
            <span>✔ Secure & Scalable</span>
            <span>✔ Modern UI</span>
            <span>✔ API Ready</span>
          </div>

          <div className="platform-actions3">
            <a href="/contact" className="btn-primary3">Talk to Us</a>
          </div>

        </div>
        <img className='bannerimgmob' src="/assets/opbg/webog.png" alt="" />
      </div>


      {/* Sections */}
      <div className="platform-sections3">
        <div className="sections-container3">
          <div className="sections-sidebar3">
            <h3>Sections</h3>
            <ul className="section-nav3">
              {platformData.sections.map((section, index) => (
                <li key={index}>
                  <a
                    href={`#${section.id}`}
                    className="section-nav-link3"
                    style={{ '--hover-color': platformData.color }}
                  >
                    {section.title}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="sections-content3">
            {platformData.sections.map((section, index) => (
              <section
                key={index}
                id={section.id}
                ref={el => sectionRefs.current[section.id] = el}
                className="platform-section3"
              >
                <div className="section-header3">
                  <h2>{section.title}</h2>
                </div>
                <p className="section-description3">{section.description}</p>

                {/* Image Carousel Section */}
                <div className="section-carousel3">
                  <h4>Website Screenshots</h4>
                  <div className="carousel-container3">
                    <div className="carousel-wrapper3">
                      <button
                        className="carousel-btn3 prev-btn3"
                        onClick={() => prevImage(section.id)}
                        style={{ backgroundColor: platformData.color }}
                      >
                        ‹
                      </button>

                      <div className="carousel-image-container3">
                        <img
                          src={section.images[activeImageIndex[section.id] || 0]}
                          alt={`${section.title} screenshot ${(activeImageIndex[section.id] || 0) + 1}`}
                          className="carousel-image3"
                          loading="lazy"
                        />
                        <div className="image-indicator3">
                          {section.images.map((_, imgIndex) => (
                            <button
                              key={imgIndex}
                              className={`indicator-dot3 ${(activeImageIndex[section.id] || 0) === imgIndex ? 'active' : ''}`}
                              onClick={() => goToImage(section.id, imgIndex)}
                              style={{
                                backgroundColor: (activeImageIndex[section.id] || 0) === imgIndex
                                  ? platformData.color
                                  : '#ccc'
                              }}
                            />
                          ))}
                        </div>
                      </div>

                      <button
                        className="carousel-btn3 next-btn3"
                        onClick={() => nextImage(section.id)}
                        style={{ backgroundColor: platformData.color }}
                      >
                        ›
                      </button>
                    </div>

                    <div className="carousel-thumbnails3">
                      {section.images.map((image, imgIndex) => (
                        <button
                          key={imgIndex}
                          className={`thumbnail3 ${(activeImageIndex[section.id] || 0) === imgIndex ? 'active' : ''}`}
                          onClick={() => goToImage(section.id, imgIndex)}
                        >
                          <img
                            src={image}
                            alt={`Thumbnail ${imgIndex + 1}`}
                            loading="lazy"
                          />
                        </button>
                      ))}
                    </div>
                  </div>
                </div>

                {/* Website Links */}
                <div className="section-links3">
                  <div className="links-container3">
                    <a
                      href={section.liveLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="live-link3"
                      style={{ backgroundColor: platformData.color }}
                    >
                      <span className="link-icon3">🌐</span>
                      <div>
                        <div className="link-title3">Live Website</div>
                        {/* <div className="link-subtitle">Visit the live production site</div> */}
                      </div>
                      {/* <span className="link-arrow">→</span> */}
                    </a>
                  </div>
                </div>

                <div className="section-features3">
                  <h4>Key Features</h4>
                  <ul className="features-list3">
                    {section.features.map((feature, featureIndex) => (
                      <li key={featureIndex}>
                        <div className="feature-icon3" style={{ color: platformData.color }}>
                          ✓
                        </div>
                        <span>{feature}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="section-items3">
                  <h4>Categories</h4>
                  <ul className="items-grid3">
                    {section.items.map((item, itemIndex) => (
                      <li
                        key={itemIndex}
                        className="item-card3"
                        style={{ borderLeftColor: platformData.color }}
                      >
                        <div className="item-bullet3" style={{ backgroundColor: platformData.color }}></div>
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="section-cta3">
                  <button
                    className="cta-button3"
                    style={{ backgroundColor: platformData.color }}
                    onClick={() => window.open(section.liveLink, '_blank')}
                  >
                    Visit {section.title} Website
                  </button>
                </div>
              </section>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Website;